export interface RuntimePlaceholderDefinition {
  key: string;
  label: string;
  description: string;
  sample: string;
}

export const RUNTIME_PLACEHOLDERS: readonly RuntimePlaceholderDefinition[] = [
  { key: "opening_context", label: "开局设定", description: "人物创建后固化的开局世界与身份背景。", sample: "玩家在公会据点完成登记。" },
  { key: "runtime_context", label: "权威运行时", description: "玩家、任务、物品、角色、怪物与游戏时间的当前状态。", sample: "当前地点：公会据点；第 1 日 08:00。" },
  { key: "rag_context", label: "检索资料", description: "本轮词法或向量检索命中的正史资料。", sample: "怪物生态与任务资料片段。" },
  { key: "memory_context", label: "叙事记忆", description: "近期结构化记忆与关系变化。", sample: "玩家曾帮助据点补给班。" },
  { key: "deep_summary", label: "深度总结", description: "窗口之外更早历史的增量摘要。", sample: "更早旅程摘要。" },
  { key: "guidance_context", label: "世界观指导", description: "本轮导演、正史边界与世界书指导。", sample: "遵守公会许可与生态逻辑。" },
  { key: "player_name", label: "玩家名", description: "当前玩家角色姓名。", sample: "苍岚" },
  { key: "lastUserMessage", label: "当前输入", description: "本轮玩家原始输入。", sample: "我去任务板看看。" },
] as const;

export function resolveRuntimePlaceholders(content: string, vars: Record<string, string>) {
  return content.replace(/\$\{([^}]+)\}/g, (match, name: string) => {
    const key = name.trim();
    return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key]! : match;
  });
}

export function previewRuntimePlaceholders(content: string) {
  const values = Object.fromEntries(RUNTIME_PLACEHOLDERS.map((item) => [item.key, item.sample]));
  return resolveRuntimePlaceholders(content, values);
}
